// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HXom","requiredAsterisk":"Info_requiredAsterisk__2sLXJ"};